import { render, staticRenderFns } from "./vdc-tabs.vue?vue&type=template&id=0fff80c6&scoped=true"
import script from "./vdc-tabs.vue?vue&type=script&lang=js"
export * from "./vdc-tabs.vue?vue&type=script&lang=js"
import style0 from "./vdc-tabs.vue?vue&type=style&index=0&id=0fff80c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fff80c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
